module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå detalj 2023 7.e56d8c58.jpg";